/**
 * Define the HTML code for the "Help" page.
 * @returns HTML code for the "Help" page
 */

import { TextBackground } from "../components";

export const Help = () => {
	const commonWidth = "80%";

	return (
		<section className="page">

			<h1>Tutorials</h1>
			<TextBackground width={commonWidth}>
			<h2>WebServer overview and a simple STEGG 2.0 run</h2>
			<video controls width="80%">
			<source src={require("../media/stegg_tutorial.mp4")} type="video/mp4"></source>
			Sorry, your browser doesn't support videos.
			</video>

			</TextBackground>

		</section>
	);
};